/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import util from '../../../utils/util';
import flagImg from '../../assets/footer/flag.png';

let $ = window.$;

const COLORS = {
    roles:       { bg: '#1e3a5f', accent: '#60a5fa', border: '#2d5a8e' },
    facilities:  { bg: '#1a3350', accent: '#93c5fd', border: '#274d7a' },
    standards:   { bg: '#0c4a6e', accent: '#38bdf8', border: '#0369a1' },
    assessments: { bg: '#3b0764', accent: '#c084fc', border: '#6b21a8' },
    schedules:   { bg: '#451a03', accent: '#fbbf24', border: '#92400e' },
    analytics:   { bg: '#083344', accent: '#22d3ee', border: '#0e7490' },
    compliance:  { bg: '#052e16', accent: '#4ade80', border: '#166534' },
    kpis:        { bg: '#450a0a', accent: '#f87171', border: '#991b1b' },
    surveys:     { bg: '#1e3a8a', accent: '#818cf8', border: '#3730a3' },
    qindex:      { bg: '#2e1065', accent: '#e879f9', border: '#7e22ce' },
    executive:   { bg: '#042f2e', accent: '#2dd4bf', border: '#0f766e' },
    custom:      { bg: '#0c2a4a', accent: '#7dd3fc', border: '#0369a1' },
    approvals:   { bg: '#052e16', accent: '#86efac', border: '#15803d' },
    amber:       { bg: '#431407', accent: '#fb923c', border: '#c2410c' },
    cap:         { bg: '#1a0533', accent: '#f0abfc', border: '#7e22ce' },
    team:        { bg: '#0c1a3a', accent: '#93c5fd', border: '#1e40af' },
    profile:     { bg: '#0a1f1a', accent: '#6ee7b7', border: '#065f46' },
    import:      { bg: '#18302a', accent: '#34d399', border: '#059669' },
    manual:      { bg: '#172554', accent: '#bfdbfe', border: '#1e40af' },
    access:      { bg: '#2e1065', accent: '#a78bfa', border: '#6d28d9' },
    hie:         { bg: '#052e16', accent: '#6ee7b7', border: '#065f46' },
    periods:     { bg: '#431407', accent: '#fdba74', border: '#9a3412' },
    trail:       { bg: '#172554', accent: '#bfdbfe', border: '#1e40af' },
    awards:      { bg: '#422006', accent: '#facc15', border: '#854d0e' },
    default:     { bg: '#1e293b', accent: '#94a3b8', border: '#334155' },
};

// Map path prefix to color key
const pathColor = (path) => {
    if (!path) return 'default';
    if (path.includes('/roles'))              return 'roles';
    if (path.includes('/facilities'))         return 'facilities';
    if (path.includes('/standards'))          return 'standards';
    if (path.includes('/assessments'))        return 'assessments';
    if (path.includes('/assessment-import'))  return 'import';
    if (path.includes('/approval'))           return 'approvals';
    if (path.includes('/cap'))                return 'cap';
    if (path.includes('/team'))               return 'team';
    if (path.includes('/facility-profile'))   return 'profile';
    if (path.includes('/facility-coord'))     return 'hie';
    if (path.includes('/user-manual'))        return 'manual';
    if (path.includes('/ays'))                return 'assessments';
    if (path.includes('/me/'))                 return 'analytics';
    if (path.includes('/nominations'))        return 'awards';
    if (path.includes('/programs'))           return 'amber';
    if (path.includes('/judge'))              return 'awards';
    if (path.includes('/awards'))             return 'awards';
    if (path.includes('/survey-builder'))     return 'amber';
    if (path.includes('/my-surveys'))         return 'surveys';
    if (path.includes('/analytics'))          return 'analytics';
    if (path.includes('/compliance'))         return 'compliance';
    if (path.includes('/kpis'))               return 'kpis';
    if (path.includes('/surveys'))            return 'surveys';
    if (path.includes('/quality-index'))      return 'qindex';
    if (path.includes('/executive'))          return 'executive';
    if (path.includes('/facility-report'))    return 'custom';
    if (path.includes('/activity-trail'))     return 'trail';
    if (path.includes('/online-users'))       return 'trail';
    if (path.includes('/periods'))            return 'periods';
    if (path.includes('/schedules'))          return 'schedules';
    if (path.includes('/access-control'))     return 'access';
    if (path.includes('/hie-sync'))           return 'hie';
    return 'default';
};

function NavSection({ sectionKey, label, children, hasActiveChild }) {
    const storageKey = `nav_collapsed_${sectionKey}`;
    const [collapsed, setCollapsed] = useState(() => {
        if (hasActiveChild) return false;
        try { return localStorage.getItem(storageKey) === '1'; } catch { return false; }
    });
    useEffect(() => {
        if (hasActiveChild && collapsed) {
            setCollapsed(false);
            try { localStorage.removeItem(storageKey); } catch {}
        }
    }, [hasActiveChild]);
    const toggle = () => {
        const next = !collapsed;
        setCollapsed(next);
        try { localStorage.setItem(storageKey, next ? '1' : '0'); } catch {}
    };
    return (
        <>
            <li style={{ listStyle: 'none', padding: '10px 16px 4px' }}>
                <button onClick={toggle} style={{ width:'100%', background:'none', border:'none', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'space-between', padding:0 }}>
                    <span style={{ fontSize:11, fontWeight:800, color:'#f59e0b', letterSpacing:1.2, textTransform:'uppercase', textShadow:'0 0 12px rgba(245,158,11,0.3)', whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis', textAlign:'left', flex:1 }}>{label}</span>
                    <span style={{ fontSize:11, color:'#f59e0b', transform:collapsed?'rotate(-90deg)':'rotate(0deg)', transition:'transform 0.2s', display:'inline-block', lineHeight:1 }}>▾</span>
                </button>
            </li>
            <li style={{ listStyle:'none', overflow:'hidden' }}>
                <div style={{ maxHeight:collapsed?0:'600px', opacity:collapsed?0:1, transition:'max-height 0.25s ease, opacity 0.2s ease', overflow:'hidden' }}>
                    <ul style={{ listStyle:'none', margin:0, padding:0 }}>{children}</ul>
                </div>
            </li>
        </>
    );
}

function NavItem({ to, label, icon, colorKey, isActive, badge }) {
    const c = COLORS[colorKey] || COLORS.default;
    return (
        <li style={{ margin:'1px 8px', listStyle:'none' }}>
            <Link to={to} style={{ display:'flex', alignItems:'center', gap:10, padding:isActive?'10px 13px 10px 16px':'9px 13px', borderRadius:8, fontSize:13.5, fontWeight:isActive?800:600, color:'#ffffff', background:isActive?c.bg:'transparent', border:isActive?`1px solid ${c.border}`:'1px solid transparent', textDecoration:'none', transition:'all 0.15s', position:'relative', overflow:'hidden' }}>
                {isActive && <span style={{ position:'absolute', left:0, top:0, bottom:0, width:3, background:c.accent, borderRadius:'0 2px 2px 0' }}/>}
                <span style={{ fontSize:16, flexShrink:0, lineHeight:1, filter:isActive?`drop-shadow(0 0 4px ${c.accent})`:'none' }}>{icon}</span>
                <span style={{ color:isActive?c.accent:'#cbd5e1', fontWeight:isActive?800:600, fontSize:13.5, flex:1, whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>{label}</span>
                {badge > 0 && <span style={{ background:'#ef4444', color:'#fff', fontSize:10, fontWeight:700, padding:'1px 6px', borderRadius:10, flexShrink:0 }}>{badge}</span>}
            </Link>
        </li>
    );
}

function NavDivider() {
    return <li style={{ listStyle:'none', margin:'6px 16px 2px' }}><div style={{ height:1, background:'#1e293b' }}/></li>;
}

export default function Leftnavs() {
    const location   = useLocation();
    const [tick, setTick] = useState(0);

    useEffect(() => {
        const m = util.getModules?.() || {};
        if (Object.keys(m).length === 0) {
            const id = setInterval(() => {
                setTick(t => t + 1);
                if (Object.keys(util.getModules?.() || {}).length > 0) clearInterval(id);
            }, 300);
            return () => clearInterval(id);
        }
    }, []);

    const isAdminFlag  = parseInt(localStorage.getItem('is_admin') || '0');
    const isSuperAdmin = parseInt(localStorage.getItem('user_id') || '0') === 1 || isAdminFlag === 1;
    const isProgramUser = util.isProgramUser?.() || false;
    const rawNav       = util.getNav?.() || [];
    // Program users only see Survey Builder nav items
    const nav = isProgramUser
        ? rawNav.filter(item => item.group_name === 'Survey Builder')
        : rawNav;

    const isActive = useCallback(
        path => location.pathname === path || location.pathname.startsWith(path + '/'),
        [location]
    );
    const closeResponsiveSidebar = useCallback(() => {
        if (window.innerWidth < 992) {
            document.body.classList.remove('sidebar-open');
            if ($ && $.fn) $('body').removeClass('sidebar-open');
        }
    }, []);

    // Group nav items by group_name (order preserved from DB)
    const grouped = nav.reduce((acc, item) => {
        const g = item.group_name || 'Other';
        if (!acc[g]) acc[g] = [];
        acc[g].push(item);
        return acc;
    }, {});

    // Add superadmin-only items that aren't in the DB nav
    if (isSuperAdmin) {
        if (!grouped['Reports']) grouped['Reports'] = [];
        const hasOnlineUsers = grouped['Reports'].some(i => i.path === '/qoc/online-users');
        if (!hasOnlineUsers) {
            grouped['Reports'].push({ key:'online_users', name:'Online Users', path:'/qoc/online-users', icon:'🟢', order:99 });
        }
    }

    return (
        <>
            <div className="page-sidebar-cover" onClick={closeResponsiveSidebar}/>
            <div className="page-sidebar-wrapper d-print-none">
                <div className="page-sidebar navbar-collapse1 collapse1">
                    <div style={{ display:'flex', flexDirection:'column', height:'100vh', background:'#0f172a', overflow:'hidden' }}>

                        {/* Brand */}
                        <div style={{ flexShrink:0, padding:'16px 16px 13px', borderBottom:'1px solid #1e293b' }}>
                            <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                                <div style={{ width:36, height:36, borderRadius:9, flexShrink:0, background:'linear-gradient(135deg,#1890ff,#0ea5e9)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:17, overflow:'hidden' }}>
                                    <img src={flagImg} alt="Flag of Eswatini" style={{ width:'100%', height:'100%', objectFit:'cover' }}/>
                                </div>
                                <div>
                                    <div style={{ fontWeight:800, fontSize:13, color:'#f1f5f9' }}>QoC Platform</div>
                                    <div style={{ fontSize:10, color:'#475569', fontWeight:600 }}>NQMP · Eswatini MoH</div>
                                </div>
                            </div>
                        </div>

                        {/* Dynamic nav sections */}
                        <ul className="page-sidebar-menu" style={{ flex:1, overflowY:'auto', overflowX:'hidden', padding:'8px 0 24px', listStyle:'none', margin:0 }}>
                            {Object.entries(grouped).map(([groupName, items]) => {
                                const sectionKey = groupName.toLowerCase().replace(/\s+/g, '_');
                                const paths = items.map(i => i.path);
                                const hasActiveChild = paths.some(p => isActive(p));
                                return (
                                    <NavSection key={sectionKey} sectionKey={sectionKey} label={groupName} hasActiveChild={hasActiveChild}>
                                        {items
                                            .sort((a, b) => (a.order || 0) - (b.order || 0))
                                            .map(item => (
                                                <NavItem
                                                    key={item.key}
                                                    to={item.path}
                                                    label={item.name}
                                                    icon={item.icon || '📄'}
                                                    colorKey={pathColor(item.path)}
                                                    isActive={isActive(item.path)}
                                                />
                                            ))
                                        }
                                        <NavDivider/>
                                    </NavSection>
                                );
                            })}

                            {/* Welcome link always visible */}
                            {nav.length === 0 && (
                                <li style={{ listStyle:'none', padding:'20px 16px', color:'#475569', fontSize:12 }}>
                                    No pages assigned. Contact your administrator.
                                </li>
                            )}
                        </ul>
                    </div>
                </div>
            </div>
        </>
    );
}

